export const EXTERNAL_PROVIDERS: string[] = ['2gis'];
